module.exports = __webpack_public_path__ + "img/decimal_to.cbf658f1.png";